import {
  FormTabs
} from "@wac-ui-dashboard/wac_component_library";
import Style from "./advertisementForm.module.scss";
import useUpdateAdvertisement from "./useUpdateAdvertisement";

const UpdateAdvertisement = ({ activeId, refetch, isEditData }) => {
  const {
    tabs,
    activeTab,
    handleMoveToErrorTab,
    handleTabClick,
    renderTabContent,
    formik,
  } = useUpdateAdvertisement({
    activeId,
    refetch,
    isEditData,
  });

  return (
    <>
    <FormTabs
      propStyle={{ root: Style.formTabs_root }}
      tabs={tabs}
      active={activeTab}
      handleClick={handleTabClick}
    />
    <form onSubmit={(e) => {formik.handleSubmit(e); handleMoveToErrorTab();}}>{renderTabContent()}</form>
  </>
  );
};
export default UpdateAdvertisement;
